import React, { useMemo } from 'react';
import { Table, Tag } from 'antd';

import formatPrice from '~helpers/currency';

import Card from '~client/components/card';

export default function CommissionInfo({ t, commissionInfo = {} }) {
  const columns = useMemo(
    () => [
      {
        title: t('cms.booking.manual_property.detail.commission_info.commission_number'),
        dataIndex: 'commissionNumber',
        key: 'commissionNumber',
        width: 144,
        render: (_, record) => <span className="table-field">{record?.referenceId ?? '-'}</span>,
      },
      {
        title: t('cms.booking.manual_property.detail.commission_info.booking_number'),
        dataIndex: 'bookingNumber',
        key: 'bookingNumber',
        width: 144,
        render: (_, record) => <span className="table-field">{record?.referenceId ?? '-'}</span>,
      },
      {
        title: t('cms.booking.manual_property.detail.commission_info.final_price'),
        dataIndex: 'totalRent',
        key: 'totalRent',
        width: 120,
        render: (_, record) => (
          <span className="table-field">
            {record?.finalPrice ? formatPrice(record?.finalPrice, record?.currency) : '-'}
          </span>
        ),
      },
      {
        title: t('cms.booking.manual_property.detail.commission_info.commission_tier'),
        dataIndex: 'commissionTier',
        key: 'commissionTier',
        width: 180,
        render: (_, record) => {
          const type = record?.interestedXbooking?.commission?.calculationType;
          const value = record?.interestedXbooking?.commission?.calculationValue;
          return (
            <div className="table-field" style={{ textAlign: 'center', verticalAlign: 'center' }}>
              <span>{value && type === 'PERCENTAGE' ? `${value}%` : value ?? '-'}</span>
              {record?.interestedXbooking?.commission?.data?.tier?.name && (
                <Tag className="commison-plan__plan-card__basic-info__default-tag commission-tier">
                  <span>{record?.interestedXbooking?.commission?.data?.tier?.name}</span>
                </Tag>
              )}
            </div>
          );
        },
      },
      {
        title: t('cms.booking.manual_property.detail.commission_info.commission_charged'),
        dataIndex: 'commissionCharged',
        key: 'commissionCharged',
        width: 120,
        render: (_, record) => (
          <div className="table-field">{record?.interestedXbooking?.commission?.value ?? '-'}</div>
        ),
      },
      {
        title: t('cms.booking.manual_property.detail.commission_info.bonus_commission_tier'),
        dataIndex: 'bonusCommissionTier',
        key: 'bonusCommissionTier',
        width: 120,
        render: (_, record) => {
          const type = record?.interestedXbooking?.commission?.bonusCalculationType;
          const value = record?.interestedXbooking?.commission?.bonusCalculationValue;
          return (
            <div className="table-field">
              {value && type === 'PERCENTAGE' ? `${value}%` : value ?? '-'}
            </div>
          );
        },
      },
      {
        title: t('cms.booking.manual_property.detail.commission_info.bonus_commission_charged'),
        dataIndex: 'bonusCommissionCharged',
        key: 'bonusCommissionCharged',
        width: 120,
        render: (_, record) => (
          <div className="table-field">
            {record?.interestedXbooking?.commission?.bonusValue ?? '-'}
          </div>
        ),
      },
      {
        title: t('cms.booking.manual_property.detail.commission_info.total_commission_charged'),

        key: 'totalCommissionCharged',
        width: 120,
        render: (_, record) => (
          <div className="table-field">
            {record?.interestedXbooking?.commission?.totalCommissionValue ?? '-'}
          </div>
        ),
      },
      {
        title: t('cms.booking.manual_property.detail.commission_info.commission_converted'),

        key: 'commissionConvertedUsd',
        width: 120,
        render: (_, record) => (
          <div className="table-field">
            {record?.interestedXbooking?.commission?.commissionConvertedUsd ?? '-'}
          </div>
        ),
      },
      {
        title: t('cms.booking.manual_property.detail.commission_info.agent_service_fee'),

        key: 'agent_service_fee',
        width: 120,
        render: (_, record) => (
          <div className="table-field">{record?.agentServiceFeeInRmb ?? '-'}</div>
        ),
      },
      {
        title: t(
          'cms.booking.manual_property.detail.commission_info.commission_charge_status.title',
        ),
        dataIndex: 'commissionChargeStatus',
        key: 'commissionChargeStatus',
        width: 120,
        render: (_, record) => (
          <div className="table-field">
            {record?.landlordBookingStatus
              ? t(
                  `cms.booking.manual_property.detail.commission_info.commission_charge_status.${record?.landlordBookingStatus?.toLowerCase()}`,
                )
              : '-'}
          </div>
        ),
      },
    ],
    [],
  );

  return (
    <Card
      id="commission_info"
      title={t('cms.booking.manual_property.detail.commission_info.commission_info')}
    >
      <Table
        className="table-wrapper"
        columns={columns}
        dataSource={[commissionInfo]}
        pagination={false}
      />
    </Card>
  );
}
